function enumValueToString(enumeration, enumValue) {
  return enumValue.toString();
}
export {
  enumValueToString
};
//# sourceMappingURL=enum-value-to-string.js.map
